module.exports = __webpack_public_path__ + "static/media/obj1.8f95bb1d.png";